<template>
  <section class="icon-wrap" :class="bgc" id="overview">
    <ul class="d-f fw-w fs-20 ta-c c-333" :class="equalPartPadding">
      <li class="d-f jc-c fd-c ai-c reveal" :class="equalParts" v-for="(item, index) in iconWrapData" :key="index">
        <div class="img-box">
          <svg-icon :icon-class="item.icon" class-name="custom-class" />
        </div>
        <div class="text" v-html="$t(item.vHtml)"></div>
      </li>
    </ul>
    <div v-if="isShowTip" class="tips ta-r">
      <div><i class="c-fa0">*</i>&nbsp;<span class="fs-20 c-999">Paid feature</span></div>
      <div><i class="c-f24130ff">*</i>&nbsp;<span class="fs-20 c-999">Customized</span></div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      iconWrapData: {
        type: Array,
        default: () => []
      },
      // 是否显示底部注释提示
      isShowTip: {
        type: Boolean,
        default: false
      },
      bgc: {
        type: String,
        default: 'bgc-fafafa'
      }
    },
    data() {
      return {}
    },
    computed: {
      // 根据 icon 数量来均分宽度
      equalParts() {
        return this.iconWrapData.length === 8 ? 'four-equal-parts' : 'three-equal-parts'
      },
      equalPartPadding() {
        return this.iconWrapData.length === 8 ? 'four-warp-parts' : 'three-warp-parts'
      }
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .icon-wrap {
    padding: 0.64rem 0;
  }
  // .icon-wrap ul {
  //   padding: 0 3.52rem;
  // }
  .four-warp-parts {
    padding: 0 3.52rem;
  }
  .three-warp-parts {
    padding: 0 2.76rem;
  }
  .four-equal-parts {
    width: calc(100% / 4);
    height: 2.68rem;
  }
  .three-equal-parts {
    width: calc(100% / 3);
    height: 2.68rem;
  }
  .icon-wrap li .img-box {
    margin-bottom: 0.08rem;
    width: 1.36rem;
    height: 1.36rem;
  }
  .custom-class {
    width: 1.36rem;
    height: 1.36rem;
  }
  .icon-wrap .tips {
    margin: 0.32rem 1.4rem 0 0;
  }
</style>
